import { SpringRestApi } from "@oceanjs/core";
import { SpringRestConfig } from "./SpringRestConfig";
import { ImportProtokoll } from "./model";

const resource = SpringRestConfig.endpoints.importprotokolle;
export const ImportProtokollApi = new SpringRestApi<ImportProtokoll>(resource);
